import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-sold-table-summary',
  templateUrl: './vehicle-sold-table-summary.component.html',
  styleUrls: ['./vehicle-sold-table-summary.component.scss']
})
export class VehicleSoldTableSummaryComponent implements OnInit {

  // --- Main Stats ---
  totalVisits: number = 29;
  soldCount: number = 8;
  newCount: number = 7;
  usedCount: number = 1;
  fStatusCount: number = 2;

  // --- Performance Metrics ---
  vsa = { count: 3, percentage: 37 };
  ppm = { count: 4, percentage: 50 };
  cce = { count: 3, percentage: 37 };
  pruValue: number = 1390; // Representing $1,390

  // --- Follow Up Section ---
  reportTitle: string = "Follow Up Report";
  totalOutbound: number = 89;
  salesAppts: number = 2;
  tomorrowAppts: number = 7;
  wedAppts: number = 7; // Assuming "WED APTS" also means 7

  // --- Trades ---
  trades = { count: 3, outOf: 8 };

  constructor() { }

  ngOnInit(): void {
    // You could fetch this data from a service here in a real application
  }

}
